import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { useAsrProxyConsoleContext } from '../../providers/AsrProxyConsoleProvider';
import type { TTab } from '../../types/TTab';

const tabs: { id: TTab; label: string }[] = [
  { id: 'playground', label: 'Playground' },
  { id: 'models', label: 'Models & Providers' },
  { id: 'jobs', label: 'Recent Jobs' },
  { id: 'defaults', label: 'Defaults' },
  { id: 'docs', label: 'Docs' },
];

export const TabsNav = () => {
  const { tab, setTab } = useAsrProxyConsoleContext();

  return (
    <HeaderSwitchWrapper>
      {tabs.map(({ id, label }) => (
        <SwitchButton key={id} active={tab === id} onClick={() => setTab(id)}>
          {label}
        </SwitchButton>
      ))}
    </HeaderSwitchWrapper>
  );
};
